/* eslint-disable no-underscore-dangle */
/* eslint-disable no-empty */
/* eslint-disable no-param-reassign */
// src/api/index.js
import axios from 'axios';
import keycloak, { loginWithCurrentUrl } from '@/keycloak';

const runtimeURL = window.__ENV__?.API_BASE_URL;
const baseURL = runtimeURL
  || process.env.VUE_APP_API_BASE_URL
  || import.meta?.env?.VITE_API_BASE_URL
  || (window.location.hostname === 'localhost'
    ? 'http://localhost:8000/api'
    : '/backend');

const api = axios.create({ baseURL });

// Rutas de lectura pública (QR)
const PUBLIC_GET = [
  /^\/activo\/unique\/[^/]+$/,
  /^\/activo\/main-image-resource\/[^/]+$/,
  /^\/activo\/category\/[^/]+$/,
  /^\/activo\/address\/[^/]+$/,
  /^\/activo\/filtered-resource\/[^/]+$/,
  /^\/activo\/resources\/[^/]+$/,
];

function isPublic(config) {
  // solo GET y rutas listadas
  if (config.method?.toLowerCase() !== 'get') return false;
  const path = (config.url || '').replace(baseURL, '');
  return PUBLIC_GET.some((re) => re.test(path));
}

api.interceptors.request.use(
  async (config) => {
    if (isPublic(config)) return config; // nada de bearer

    try {
      await keycloak.updateToken(30);
      config.headers = config.headers || {};
      if (keycloak.token) config.headers.Authorization = `Bearer ${keycloak.token}`;
    } catch {
      await loginWithCurrentUrl(); // fuerza login, preservando URL actual
      throw new axios.Cancel('Redirecting to login');
    }
    return config;
  },
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    if (error?.response?.status === 401) {
      try { await loginWithCurrentUrl(); } catch {}
    }
    return Promise.reject(error);
  },
);

export default api;
